const mapFacetsToBrands = (facets) => {
  if (!facets) {
    return null;
  }

  const brands = {
    other: [],
  };

  for (let i = 0; i < facets.length; i += 1) {
    const value = facets[i];
    const firstCharacter = value.title.charAt(0).toLowerCase();

    if (/[a-z]/.test(firstCharacter)) {
      if (!brands[firstCharacter] || !Array.isArray(brands[firstCharacter])) {
        brands[firstCharacter] = [];
      }

      brands[firstCharacter].push(value);
    } else {
      brands.other.push(value);
    }
  }

  return brands;
};

export const useBrandOverviewTemplate = async ({ $api }: any) => {
  const pageUrl = useGetPageUrl({ encode: true });
  const { data: brands } = await useAsyncData(() => $api.getNodes(unref(pageUrl), true));

  return {
    brands: mapFacetsToBrands(unref(brands).nodes),
  };
};
